import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-features-third',
  templateUrl: './our-features-third.component.html',
  styleUrls: ['./our-features-third.component.scss']
})
export class OurFeaturesThirdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
